import './_account-login-register.scss';
import component from './account-login-register';

export default component;
